import styled from 'styled-components';

import fonts from 'apps/promo/theme/fonts';
import promoColors from 'apps/promo/theme/promoColors';
import promoMedia from 'apps/promo/theme/promoMedia';

/* styles for common section (components inside it) */
export const CommonSection = styled.section`
    background: ${(props) => promoColors[props.bgColor]};
    padding-bottom: 32px;

    ${promoMedia.tablet744} {
        padding-bottom: 48px;
    }

    ${promoMedia.desktop1440} {
        padding-bottom: 64px;
    }
`;

/* carousel dots */
export const CarouselDotGroup = styled.div`
    width: 100%;
    position: ${(props) => (props.$isInsideTile ? 'absolute' : null)};
    bottom: ${(props) => (props.$isInsideTile ? '40px' : null)};

    ${promoMedia.tablet744} {
        bottom: ${(props) => (props.$isInsideTile ? '48px' : null)};
    }

    ${promoMedia.desktop1440} {
        bottom: ${(props) => (props.$isInsideTile ? '56px' : null)};
    }

    & > div {
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 8px;
    }

    button {
        background-color: ${promoColors.gray20};
        padding: 0;
        cursor: pointer;
        border-radius: 50%;
        height: 8px;
        width: 8px;
    }

    button:disabled {
        background-color: ${promoColors.primary};
        cursor: pointer;
    }
`;

/* dangerously html styles */
export const TextComponent = styled.div`
    .color-medium-gray {
        color: ${promoColors.gray40};
    }

    img {
        max-width: 100%;
        border: none;
        height: auto;

        ${promoMedia.desktop1440} {
            max-width: 704px;
        }
    }

    p + p,
    p + figure,
    p + ul,
    p + ol,
    p + .news-article {
        margin-top: 1em;
    }

    h1,
    h2,
    h3,
    h4 {
        margin-bottom: 1em;
        margin-top: 1em;
    }

    h1 {
        font-size: 24px;
        line-height: 40px;
    }

    h2,
    .title2 {
        font-size: 20px;
        line-height: 32px;
    }

    h3 {
        font-size: 18px;
        line-height: 28px;
    }

    h4,
    .maincopy {
        font-size: 17px;
        line-height: 24px;
    }

    ol {
        list-style-type: decimal;
        ol {
            counter-reset: item;
            list-style-type: none;

            li {
                margin-left: 30px;

                &::before {
                    counter-increment: item;
                    content: counter(item, lower-alpha) ') ';
                    left: -16px;
                    position: absolute;
                    top: 6px;
                }
            }
        }
    }

    ol,
    ul {
        li {
            margin-bottom: 16px;
            margin-left: 32px;
            position: relative;
            padding: 0 !important;

            &:before {
                content: '' !important;
            }
        }
    }

    ul li {
        list-style: disc outside;
    }

    li > ul {
        margin-top: 16px;
    }

    blockquote {
        padding-top: 40px;
        position: relative;

        &::before {
            background: transparent
                url('data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz48c3ZnIHdpZHRoPSIzMiIgaGVpZ2h0PSIzMiIgdmlld0JveD0iMCAwIDMyIDMyIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZlcnNpb249IjEuMSI+PHBhdGggZD0iTTEwLjkyMzYgMTQuMzgzNEwxMy40MDY2IDguNDI0MjFDMTMuNjg4OSA3Ljc0NjY5IDEzLjE5MTEgNyAxMi40NTcxIDdDMTIuMTY2MSA3IDExLjg4ODcgNy4xMjMyNyAxMS42OTM2IDcuMzM5MjZMNC45MjY1OCAxNC44MzM3QzEuNzM5NDEgMTguMzYzNSA0LjI0NDIyIDI0ICA4Ljk5OTk5IDI0IEMxMS43NjE0IDI0IDE0IDIxLjc2MTQgMTQgMTlDMTQgMTYuOTIwMiAxMi43MzAyIDE1LjEzNyAxMC45MjM2IDE0LjM4MzRaTTIzIDI0QzE4LjI0NDIgMjQgMTUuNzM5NCAxOC4zNjM1IDE4LjkyNjYgMTQuODMzN0wyNS42OTM2IDcuMzM5MjZDMjUuODg4NyA3LjEyMzI3IDI2LjE2NjEgNyAyNi40NTcxIDdDMjcuMTkxMSA3IDI3LjY4ODkgNy43NDY2OSAyNy40MDY2IDguNDI0MjFMMjQuOTIzNiAxNC4zODM0QzI2LjczMDIgMTUuMTM3IDI4IDE2LjkyMDIgMjggMTlDMjggMjEuNzYxNCAyNS43NjE0IDI0IDIzIDI0WiIgZmlsbD0iIzE0MTQxNCIvPjwvc3ZnPg==')
                no-repeat center scroll;
            content: '';
            height: 32px;
            left: 0;
            position: absolute;
            top: 0;
            width: 32px;
        }

        .credit {
            margin-top: 25px;

            &::before {
                content: '– ';
            }
        }
    }

    .block-interview {
        margin-bottom: 48px;
        margin-top: 48px;

        [class^='cite'] {
            margin-bottom: 48px;
            margin-top: 48px;

            &::before,
            &::after {
                content: '';
                display: table;
                font-size: 0;
            }

            ::after {
                clear: both;
            }
        }

        .interview-avatar {
            border-radius: 50%;
            float: left;
            margin-right: 16px;
            margin-top: -0.5em;
            max-width: 40px;
            vertical-align: super;
            width: 40px;
        }

        .inner-content {
            margin-left: 56px;
        }
    }

    .news-player {
        height: 0;
        margin-bottom: 41px;
        margin-top: 42px;
        padding-top: 56.25%;
        position: relative;

        iframe {
            height: 100%;
            left: 0;
            max-width: 100%;
            position: absolute;
            text-align: center;
            top: 0;
            width: 100%;
        }
    }

    .text-section {
        padding-bottom: 18px;
        padding-top: 6px;

        .img-icon {
            margin-bottom: 12px;
        }
    }

    .pseudo-docs-list {
        margin-top: 24px;

        .frame {
            margin-bottom: 24px;
        }
    }

    .rich-text-button {
        font-family: ${fonts.gtStandardMMedium};
        font-weight: 500;
        font-size: 14px;
        line-height: 19px;
        display: inline-flex;
        align-items: center;
        color: ${promoColors.white};
        background: ${promoColors.primary};
        text-align: center;
        box-shadow: none;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        box-sizing: border-box;
        outline: none;
        padding: 0 24px;
        width: auto;
        height: 40px;
        border-radius: 100px;
        border: 1px solid ${promoColors.primary};

        &:link,
        &:visited {
            color: ${promoColors.white};
        }

        &:hover {
            color: ${promoColors.primary};
            background: ${promoColors.purple20};
            border: 1px solid ${promoColors.purple20};
        }

        ${promoMedia.desktop1440} {
            font-size: 16px;
            line-height: 21px;
            height: 48px;
        }
    }

    .rich-text-note {
        font-family: ${fonts.gtStandardMMedium};
        font-size: 9px;
        line-height: 12px;
    }

    a {
        ${(props) => props.linksHighlited && `text-decoration: underline !important; color: ${promoColors.primary} !important;`}

        &:hover {
            color: ${(props) => (props.linksHighlited ? promoColors.purple80 : promoColors.primary)} !important;
        }
    }

    video {
        max-width: 100%;
    }

    ${promoMedia.desktop1440} {
        h1 {
            font-size: 40px;
            line-height: 64px;
        }

        h2,
        .title2 {
            font-size: 28px;
            line-height: 48px;
        }

        h3 {
            font-size: 24px;
            line-height: 40px;
        }

        h4,
        .maincopy {
            font-size: 20px;
            line-height: 32px;
        }

        .text-section {
            padding-bottom: 24px;
            padding-top: 8px;
        }

        .pseudo-docs-list {
            margin-top: 32px;

            .frame {
                margin-bottom: 32px;
            }
        }

        .rich-text-note {
            font-size: 12px;
            line-height: 16px;
        }
    }
`;
